<template>

  <div class="content-i">
    <div class="content-box">
            <div class="row">
                <div class="col-sm-12">
                    <div class="element-wrapper">
                        <h6 class="element-header">
                            Simple Dashboard
                        </h6>
                      <div class="row">
                        <div class="col-sm-3">
                          <statistics-card-line icon="UsersIcon" :statistic="dashboardData.inbound.length" statisticTitle="Inbound" :chartData="chartData.inbound" type="area"></statistics-card-line>
                        </div>
                        <div class="col-sm-3">
                          <statistics-card-line icon="DollarSignIcon" :statistic="dashboardData.photography.length" statisticTitle="Photography" :chartData="chartData.photography" color='success' type="area"></statistics-card-line>
                        </div>
                        <div class="col-sm-3">
                          <statistics-card-line icon="ShoppingCartIcon" :statistic="dashboardData.retouching.length" statisticTitle="Retouching" :chartData="chartData.retouching" color='danger' type="area"></statistics-card-line>
                        </div>
                        <div class="col-sm-3">
                          <statistics-card-line icon="ShoppingBagIcon" :statistic="dashboardData.final_delivery.length" statisticTitle="Final Delivery" :chartData="chartData.final_delivery" color='warning' type="area"></statistics-card-line>
                        </div>

                      </div>
                    </div>
                </div>
            </div>

            <div class="element-box">
                <div class="table-responsive">
                    <table class="table table-striped table-lightborder">
                        <thead>
                            <tr>
                                <th>Session ID</th>
                                <th>Status</th>
                                <th>Channel</th>
                                <th>Type</th>
                                <th>Contributors</th>
                                <th>Products</th>
                                <th>Dropped</th>
                                <th>Created</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody >

                            <tr v-for="session in sessions" :key="session.id_photodesk_session">
                                <td class="nowrap">
                                    {{session.code}}
                                </td>
                                <td class="nowrap capitalize" :class="formatStatus(session.status)">
                                    {{formatStatus(session.status)}}
                                </td>
                                <td class="nowrap"><img :src="session.channel_logo" height="16px" alt=""></td>
                                <td class="nowrap capitalize">{{session.type}}</td>
                                <td>
                                    <div class="cell-image-list">
                                        <div v-for="contributor in formatContributors(session)" class="cell-img" :style="'background-image: url('+contributor.avatar+')'"></div>
                                    </div>
                                </td>
                                <td>
                                    <h3>{{session.product_count}}</h3>

                                </td>
                                <td>
                                    <h3 :class="{'text-danger': session.dropped_count > 0}">
                                        <span v-if="session.dropped_count > 0">{{session.dropped_count}}</span>
                                        <span v-else>-</span>
                                    </h3>

                                </td>
                                <td>
                                    {{session.created_at}}
                                </td>
                                <td>
                                    <router-link tag="a" :to="`/photodesk/sessions/${session.id_photodesk_session}`">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

    </div>
  </div>

</template>

<script>
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/EmptyState'

import VueApexCharts from 'vue-apexcharts'
import AnalyticsData from '@/mixins/analyticsData.js'
import StatisticsCardLine from '@/components/dashboard/StatisticsLine.vue'

import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [AnalyticsData, CommonFunctions],
  components: { EmptyState, Loader, StatisticsCardLine, VueApexCharts },
  data () {
    return {
      dashboardData: {
        end_of_week: [],
        final_delivery: [],
        inbound: [],
        photography: [],
        retouching: [],
        start_of_week: []
      },
      chartData: {
        final_delivery: [],
        inbound: [],
        photography: [],
        retouching: []
      },
      sessions: [],
      statusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Open', 'key': '1' },
        { 'name': 'Closed', 'key': '0' },
        { 'name': 'Cancelled', 'key': '3' }
      ],
      analyticsData: AnalyticsData
    }
  },
  mounted () {
    this.initCharts()
    this.getData()
  },
  methods: {
    initCharts () {
      var self = this
      const entries = Object.entries(self.chartData)
      for (const [key, value] of entries) {
        var data = [0, 0, 0, 0, 0]
        self.chartData[key] = self.constructChartData(data, key)
      }
    },
    getData () {
      var self = this
      const url = '/reportdesk/dashboard'

      this.$http
        .post(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.dashboardData = response.data
          self.sessions = response.data.current_sessions
          self.getChartData()
          console.log(response)
        })
        .catch(function (error) {

        })
    },
    getChartData () {
      var self = this
      var days = self.getDates(self.dashboardData.start_of_week, self.dashboardData.end_of_week)
      const entries = Object.entries(self.dashboardData)
      for (const [key, values] of entries) {
        var series = []
        if (key == 'start_of_week' || key == 'end_of_week') { continue }

        days.forEach(function (day) {
          const vals = Object.entries(values)
          var daycount = 0
          for (const [key, value] of vals) {
            if (self.moment(value.final_sent_at || value.retouch_received_at || value.inbound_at || value.inbound_at).format('YYYY-MM-DD') == day) {
              daycount = daycount + 1
            }
          }
          series.push(daycount)
        })
        self.dashboardData[key]
        self.chartData[key] = self.constructChartData(series, key)
        // console.log()
        // self.$set(self.dashboardData[key], 'series', series)
      }
    },

    getDates (startDate, stopDate) {
      var dateArray = []
      var self = this
      var currentDate = self.moment(startDate)
      var stopDate = self.moment(stopDate)
      while (currentDate <= stopDate) {
        dateArray.push(self.moment(currentDate).format('YYYY-MM-DD'))
        currentDate = self.moment(currentDate).add(1, 'days')
      }
      return dateArray
    },

    constructChartData (data, key) {
      return {
        series: [{
          name: key,
          data: data
        }],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            width: 2.5
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: 'numeric',
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: {
              show: false
            }
          },
          yaxis: [{
            y: 0,
            offsetX: 0,
            offsetY: 0,
            padding: {
              left: 0,
              right: 0
            }
          }],
          tooltip: {
            x: {
              show: false
            }
          }
        }
      }
    }
  }
}
</script>

<style>
.pb-0 {
  padding-bottom: 0 !important;
}
.p-6 {
  padding: 1.5rem !important;
}

.row > col-sm-* {
  padding: 0 1rem;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
}
.mw-25 {
  max-width: 40%;
}
.support-ticket {
  border: 1px solid #dedede;
}
.support-ticket {
    background-color: #fff;
    border-radius: 3px;
    -webkit-box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
    box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
}
</style>
